module.exports = __webpack_public_path__ + "img/grin_ios_802.png";